
<div class="custom-control custom-switch" aria-role="checkbox">
  <input class="custom-control-input" type="checkbox" [checked]="displayValue">
  <label class="custom-control-label">{{text}}</label>
</div>